import { createAsyncThunk } from '@reduxjs/toolkit';
import { QuestionWSChannels, QuestionsWSMessages } from 'common/constants';
import { uuid } from 'common/utils';
import { CreateAnswerRequest, CreateAnswerVariants } from 'domain/question';
import { SocketRoomPrefix } from 'modules/webSocket/state';
import { createWSSubscribeAction } from 'modules/webSocket/state/utils/createWSSubscribeAction';
import { createWSUnsubscribeAction } from 'modules/webSocket/state/utils/createWSUnsubscribeAction';
import { answerApi } from 'question/api';
import { createQuestionsWSMessage } from 'store/utils';

import { selectAnswers, selectQuestionAssignment } from './selectors';

import type {
  AnswerAssignedToUserIdsPayload,
  AnswerCreatedPayload,
  AnswerDeletedPayload,
  AnswerUpdatedPayload,
  DisabledPayload,
  EnabledUntilPayload,
  QuestionAssignmentWSPayload,
} from './types';
import type { RootState } from 'store';

export const questionAssignment_WS = createQuestionsWSMessage<QuestionAssignmentWSPayload>(
  QuestionsWSMessages.QuestionAssignment
);
export const enabledUntil_WS = createQuestionsWSMessage<EnabledUntilPayload>(QuestionsWSMessages.EnabledUntil);
export const disabled_WS = createQuestionsWSMessage<DisabledPayload>(QuestionsWSMessages.Disabled);
export const answerAssignedToUserIds_WS = createQuestionsWSMessage<AnswerAssignedToUserIdsPayload>(
  QuestionsWSMessages.AnswerAssignedToUserIds
);
export const answerCreated_WS = createQuestionsWSMessage<AnswerCreatedPayload>(QuestionsWSMessages.AnswerCreated);
export const answerDeleted_WS = createQuestionsWSMessage<AnswerDeletedPayload>(QuestionsWSMessages.AnswerDeleted);
export const answerUpdated_WS = createQuestionsWSMessage<AnswerUpdatedPayload>(QuestionsWSMessages.AnswerUpdated);

export const subscribeToQuestions = createWSSubscribeAction(SocketRoomPrefix.Questions, QuestionWSChannels);
export const unsubscribeFromQuestions = createWSUnsubscribeAction(SocketRoomPrefix.Questions, QuestionWSChannels);

export const submitAnswers = createAsyncThunk<void, CreateAnswerRequest[]>(
  'question/postAnswers',
  async (answers, { dispatch, getState }) => {
    const rootState = getState() as RootState;
    const perspectives = selectAnswers(rootState);

    const { assignmentId, questionId } = selectQuestionAssignment(rootState);
    const natteringAnswer = perspectives
      .map(({ text }) => text)
      .filter((text) => text)
      .join('\n');

    if (natteringAnswer && assignmentId && questionId) {
      answers.push({
        answerId: uuid(),
        assignmentId,
        isObligatory: false,
        questionId,
        type: CreateAnswerVariants.TextQuestion,
        text: natteringAnswer,
      });
    }

    answers.forEach((answer) => {
      dispatch(answerApi.endpoints.postAnswer.initiate(answer));
    });
  }
);
